module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1547-min.fc1acb05.jpg";